import React, { useState, useEffect } from 'react';
import './descriptionToggle.scss';
const DescriptionToggle = ({
  text,
  color = '#10131a',
  padding = '0 15px',
  marginTop = '0.7rem',
  marginBottom = '1rem',
  isEventsTable = false,
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  const MAX_LENGTH = 240;

  useEffect(() => {
    setIsExpanded(false);
  }, [text]);

  const handleToggle = () => {
    setIsExpanded(!isExpanded);
  };

  const isTextShortEnough = text?.length <= MAX_LENGTH;

  return (
    <div className="workload_sideovealy">
      <p className="information-heading m-0">Information</p>
      <p
        className="description-container"
        style={{
          fontFamily: 'Manrope',
          fontSize: '14px',
          color: color,
          padding: padding,
          marginBottom: marginBottom,
          marginTop: marginTop,
        }}>
        {isExpanded || isTextShortEnough ? text : `${text?.substring(0, MAX_LENGTH)}...`}
        {!isTextShortEnough && (
          <span className={`show-more-button ${isEventsTable ? 'bold-text' : ''}`} onClick={handleToggle}>
            {isExpanded ? 'Less' : 'Show More'}
          </span>
        )}
      </p>
    </div>
  );
};

export default DescriptionToggle;
